// BYMODE Theme — Main JavaScript

document.addEventListener('DOMContentLoaded', function () {

  // =====================
  // Size selector
  // =====================
  document.querySelectorAll('.product-page__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parent = this.closest('.product-page__sizes');
      parent.querySelectorAll('.product-page__size-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  // =====================
  // Newsletter form
  // =====================
  var newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      var submit = this.querySelector('.newsletter__submit');
      if (submit) {
        submit.textContent = "YOU'RE IN!";
        submit.disabled = true;
      }
    });
  }

  // =====================
  // Cart count
  // =====================
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartBtn = document.querySelector('.site-header__cart-btn');
        if (cartBtn) {
          cartBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>CART (' + cart.item_count + ')';
        }
      })
      .catch(function () {});
  }
  updateCartCount();

  // =====================
  // Cookie Banner
  // =====================
  var COOKIE_KEY = 'bymode_cookie_consent';

  function cookieConsentGiven() {
    return !!localStorage.getItem(COOKIE_KEY);
  }

  function acceptCookies() {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    hideCookieBanner();
    // Notify Shopify's Customer Privacy API if available
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(true, function () {});
    }
  }

  function declineCookies() {
    localStorage.setItem(COOKIE_KEY, 'declined');
    hideCookieBanner();
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(false, function () {});
    }
  }

  function showCookieBanner() {
    var bar = document.getElementById('bym-cookie-bar');
    if (bar) bar.classList.add('is-visible');
  }

  function hideCookieBanner() {
    var bar = document.getElementById('bym-cookie-bar');
    var overlay = document.getElementById('bym-cookie-overlay');
    var panel = document.getElementById('bym-cookie-panel');
    if (bar) bar.classList.remove('is-visible');
    if (overlay) overlay.classList.remove('is-open');
    if (panel) panel.classList.remove('is-open');
  }

  function togglePanel() {
    var panel = document.getElementById('bym-cookie-panel');
    var overlay = document.getElementById('bym-cookie-overlay');
    var toggle = document.getElementById('bym-cookie-toggle');
    if (!panel) return;
    var isOpen = panel.classList.contains('is-open');
    if (isOpen) {
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    } else {
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
  }

  if (!cookieConsentGiven()) {
    setTimeout(showCookieBanner, 1500);
  }

  var toggleBtn = document.getElementById('bym-cookie-toggle');
  if (toggleBtn) toggleBtn.addEventListener('click', togglePanel);

  var closeBtn = document.getElementById('bym-cookie-close');
  if (closeBtn) closeBtn.addEventListener('click', togglePanel);

  var acceptBarBtn = document.getElementById('bym-cookie-accept-bar');
  if (acceptBarBtn) acceptBarBtn.addEventListener('click', acceptCookies);

  var acceptBtn = document.getElementById('bym-cookie-accept');
  if (acceptBtn) acceptBtn.addEventListener('click', acceptCookies);

  var declineBtn = document.getElementById('bym-cookie-decline');
  if (declineBtn) declineBtn.addEventListener('click', declineCookies);

  // Overlay click closes panel
  var overlay = document.getElementById('bym-cookie-overlay');
  if (overlay) overlay.addEventListener('click', togglePanel);

  // =====================
  // 10% Discount Popup
  // =====================
  var POPUP_KEY = 'bymode_popup_seen';

  function openPopup() {
    var pop = document.getElementById('bym-popup');
    var popOverlay = document.getElementById('bym-popup-overlay');
    if (!pop) return;
    popOverlay.classList.add('is-open');
    pop.setAttribute('aria-hidden', 'false');
    // Trigger CSS transition: set display first, then add class on next frame
    pop.style.display = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
      });
    });
  }

  function closePopup() {
    var pop = document.getElementById('bym-popup');
    var popOverlay = document.getElementById('bym-popup-overlay');
    if (!pop) return;
    pop.classList.remove('is-open');
    pop.setAttribute('aria-hidden', 'true');
    popOverlay.classList.remove('is-open');
    localStorage.setItem(POPUP_KEY, '1');
    setTimeout(function () {
      if (!pop.classList.contains('is-open')) pop.style.display = 'none';
    }, 400);
  }

  if (!localStorage.getItem(POPUP_KEY)) {
    setTimeout(openPopup, 3500);
  }

  var popClose = document.getElementById('bym-popup-close');
  if (popClose) popClose.addEventListener('click', closePopup);

  var popSkip = document.getElementById('bym-popup-skip');
  if (popSkip) popSkip.addEventListener('click', closePopup);

  var popOverlayEl = document.getElementById('bym-popup-overlay');
  if (popOverlayEl) popOverlayEl.addEventListener('click', closePopup);

  var popForm = document.getElementById('bym-popup-form');
  if (popForm) {
    popForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = document.getElementById('bym-popup-email');
      if (!emailInput || !emailInput.value.includes('@')) {
        if (emailInput) emailInput.style.borderColor = '#c00';
        return;
      }
      var stepForm = document.getElementById('bym-popup-step-form');
      var stepSuccess = document.getElementById('bym-popup-step-success');
      if (stepForm) stepForm.style.display = 'none';
      if (stepSuccess) stepSuccess.style.display = 'block';
      localStorage.setItem(POPUP_KEY, '1');
    });
  }

});
